export const INTEGRATIONS_GET_ALL = 'INTEGRATIONS_GET_ALL';
export const INTEGRATIONS_GET_ONE = 'INTEGRATIONS_GET_ONE';
export const INTEGRATIONS_CREATE = 'INTEGRATIONS_CREATE';
export const INTEGRATIONS_ADD_NETWORK = 'INTEGRATIONS_ADD_NETWORK';
export const INTEGRATIONS_REMOVE_NETWORK = 'INTEGRATIONS_REMOVE_NETWORK';
export const INTEGRATIONS_SET_NETWORK_ACTIVE =
  'INTEGRATIONS_SET_NETWORK_ACTIVE';
export const INTEGRATIONS_UPDATE_INFO = 'INTEGRATIONS_UPDATE_INFO';
